<template>
  <div class="event-list-wrapper">
    <button v-if="hasCarousel" aria-label="Previous Slide" class="button is-reverse swiper-button swiper-button-prev">
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 13 12"><g fill="none" fill-rule="evenodd" stroke="#FCB515" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m7.55 10.442 4.226-4.432L7.55 1.577M1.55 6.01h10.226"/></g></svg>
    </button>
    <button v-if="hasCarousel" aria-label="Next Slide" class="button is-reverse swiper-button swiper-button-next">
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 13 12"><g fill="none" fill-rule="evenodd" stroke="#FCB515" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m7.55 10.442 4.226-4.432L7.55 1.577M1.55 6.01h10.226"/></g></svg>
    </button>
    <p
      class="message"
      v-if="theseResults.length == 0"
    >Check back soon for new events.</p>
    <swiper-container ref="swiper" init="false"
      v-if="hasCarousel"
    >
      <swiper-slide
        v-for="result in theseResults"
        v-bind:key="result.id">
        <event :result="result"></event>
      </swiper-slide>
    </swiper-container>
    <div v-else>
      <div
        v-for="result in theseResults"
        v-bind:key="result.id">
        <event :result="result"></event>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Event from './elementEvent.vue'
import { register } from 'swiper/element/bundle';
const { DateTime } = require('luxon')
export default {
  components: {
    Event
  },
  props: {
    position: {
      type: Number,
      required: false
    },
    hasCarousel: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    theseResults () {
      if (typeof this.position !== 'undefined') {
        const now = DateTime.local()
        const start = now.plus({ months: this.offsetMultiplier + this.position })
        // Filter results by current month start date
        return this.results.filter(function (event) {
          const startDate = new Date(event.startDate).getTime() / 1000
          const nowStartDate = start.startOf('month').toSeconds()
          const nowEndDate = start.endOf('month').toSeconds()

          return (
            startDate >= nowStartDate &&
            startDate <= nowEndDate
          )
        })
      } else {
        return this.results
      }
    },
    ...mapGetters('events', ['offsetMultiplier']),
    ...mapState('events', ['results'])
  },
  mounted: function () {
    register()
    const swiperEl = this.$refs.swiper
    const params = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: true,
      a11y: true,
      slidesPerView: 1,
      slidesPerGroup:1,
      spaceBetween: 20,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          slidesPerGroup:2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup:2,
          spaceBetween: 40,
        }
      },
      speed: 500,
      loop: false,
      injectStyles: [
        `
        :host {
          --swiper-theme-color: #015DAB;
          --swiper-navigation-size: 2rem;
          --swiper-navigation-color: #015DAB;
          --swiper-pagination-bullet-size: 12px;
          --swiper-navigation-top-offset: 25%;
        }
        :host .swiper-wrapper {
          padding-bottom: 2rem;
        }
        @media screen and (min-width: 1200px) {
          :host .swiper-wrapper {
            padding-left: 4rem;
          }
        }
        :host .swiper-pagination-bullet {
          background: #FCB515;
          opacity: 1;
        }
        :host .swiper-pagination-bullet-active {
          background: #015DAB;
        }
        :host .swiper-button-next, :host .swiper-button-prev {
          margin-top: 0;
        }
        host .swiper-button-next {
          top: 0
          right: 0;
        }
        `,
      ],
    }
    if (swiperEl) {
      Object.assign(swiperEl, params)
      swiperEl.initialize()
    }
  }
}
</script>
